export default __webpack_public_path__ + "static/media/home-banner.ea49f0f0.jpg";